import React from 'react';
import { useDispatch } from 'react-redux';
import AssignTicketOwnerShip from '../Modal/AssignTicketOwnerShip';
import { openCustomModal } from '../../../actions/modal';
import IconToolTip from '../../../common/IconToolTip';
import { textValueClass } from '../TicketTable';
import ViewTicketOwner from '../Modal/ViewTicketOwner';
import { canEditTicket } from '../TicketController';


export const OwnerColumn = ({ ticket, dataToShowPerRow = 1 }) => {
    let owners = ticket.attributes.find((elem) => elem.key === 'ticket_owners')?.value || [];
    const dispatch = useDispatch();

    const onAddClick = () => {
        const heading = 'Assign Ticket Ownership';
        const modalComponent = <AssignTicketOwnerShip project_id={ticket.project.id} owners={owners} ticket_id={ticket.id} org_id={ticket.org_id} />;

        dispatch(openCustomModal({
            heading,
            modalWidth: '60rem',
            modalHeight: 'auto',
            modalComponent,
        }));
    }


    const onViewClick = () => {
        const modalComponent = <ViewTicketOwner owners={owners} />;
        dispatch(openCustomModal({
            heading: 'Ticket Owners',
            modalWidth: '60rem',
            modalHeight: 'auto',
            modalComponent,
        }));
    }

    const showEditOwner = canEditTicket(ticket);

    return <div className="flex gap-1 items-center">
        {Array.isArray(owners) &&
            owners?.slice(0, dataToShowPerRow)?.map(({ id, value }) => {
                return (
                    <IconToolTip title={`Owner Name :${value}`} key={id} >
                        <p className="scogoprimary text-font10 mr-1 truncate">
                            <span className={'text-font10 text-scogogray'}>Owner: </span>  <span className={textValueClass + ' bg-tagbg px-2 py-1 rounded-3px max-w-max text-ellipsis truncate'}>{value}</span>
                        </p>
                    </IconToolTip>
                );
            })}
        {
            owners?.length > dataToShowPerRow && <IconToolTip onClick={onViewClick} title="View all"><span
                className="text-font12 font-normal text-scogoorange cursor-pointer hover:text-scogobgsky"
            >
                +{owners?.length - dataToShowPerRow}
            </span></IconToolTip>
        }
        {showEditOwner && <div className="flex items-center justify-between">
            {owners.length === 0 ?
                <span className='text-font10 text-scogogray pr-2'>No owner assigned</span> : null
            }
            <IconToolTip title="Edit"><span
                className="material-icons cursor-pointer text-scogobgsky text-font12 hover:text-scogoorange"
                onClick={onAddClick}
            >
                edit
            </span></IconToolTip>
        </div>}
    </div>
};